export class DateUtils {
    static format(date: Date | string, format = 'yyyy/MM/dd'): string {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
  
      if (format === 'yyyy/MM/dd') {
        return `${year}/${month}/${day}`;
      }
      if (format === 'dd/MM/yyyy') {
        return `${day}/${month}/${year}`;
      }
      // podés agregar más formatos si querés
      return d.toISOString();
    }
  }
  